import validator from 'validator';

const isValidMask = (mask, version) => validator.isInt(mask, { min: 0, max: 2 ** (version + 1) });

const parseIPv4Address = (addr) => {
  if (!validator.isIP(addr, 4)) return null;
  return addr.split('.').map(Number);
};

const ipv4ToInt = (addr) => parseIPv4Address(addr).reduce((acc, octet) => acc * 256 + octet, 0);

const intToIPv4 = (value) => [3, 2, 1, 0].map((power) => Math.floor(value / 256 ** power) % 256).join('.');

const IPValidator = (addr, version) => {
  if (!addr) return false;
  if (version === 'fqdn') return validator.isFQDN(addr);
  const ip = addr.split('/');
  return (
    validator.isIP(ip[0], version) && (ip.length === 1 || (ip.length === 2 && isValidMask(ip[1], Number(version))))
  );
};

export const normalizeIPv4Network = (addr) => {
  if (!IPValidator(addr, 4)) return null;

  const [ip, mask = '32'] = addr.split('/');
  const maskLength = Number(mask);
  const blockSize = 2 ** (32 - maskLength);
  const network = Math.floor(ipv4ToInt(ip) / blockSize) * blockSize;

  return `${intToIPv4(network)}/${maskLength}`;
};

export default IPValidator;
